import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

export const PROCEDURES = gql`
        query procedures($procedureIds: [String]) {
            procedures(procedureIds: $procedureIds) {
                id
                name
            }
        }
    `;

export const withProcedure = ({ ownProp = 'procedureId', mapResultToPropName = 'procedure' } = {}) =>
    graphql(PROCEDURES, {
        skip: ownProps => !ownProps[ownProp],
        options: ownProps => ({
            ssr: false,
            variables: { procedureIds: [ownProps[ownProp]] },
        }),
        props: ({ data: { procedures } }) => {
            if (procedures) {
                return { [mapResultToPropName]: procedures[0] };
            }
        },
    });
